import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

interface BreadcrumbItem {
  label: string;
  url: string;
}

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterLink]
})
export class BreadcrumbComponent implements OnInit, OnDestroy {
  breadcrumbs: BreadcrumbItem[] = [];
  private sub?: Subscription;

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.sub = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.breadcrumbs = this.getBreadcrumbFromRoute();
      });

    this.breadcrumbs = this.getBreadcrumbFromRoute();
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  private getBreadcrumbFromRoute(): BreadcrumbItem[] {
    let current = this.route.root;
    while (current.firstChild) {
      current = current.firstChild;
    }

    const data = current.snapshot.data.breadcrumb as BreadcrumbItem[] | undefined;
    return data ?? [];
  }
}
